import React from 'react';
import '../../../styles/utils/modal/ErrorModal.scss';
import RenderTextWithBreaks from '../RenderTextWithBreaks';
import { getLocalizedAssetPath } from '../../../utils/getLocalizedLogo';

const ErrorModal = ({ error_message, onClose }) => {
    console.log('error_message', error_message);
    return (
        <>
            <section className="error-modal-section">
                <div className="inner">
                    <figure className="sleeping-robot">
                        <img
                            src={getLocalizedAssetPath('/images/utils/modal/no-beans.svg')}
                            alt="sleeping-robot"
                            loading="lazy"
                            decoding="async"
                        />
                    </figure>
                    <div className="error-text-container">
                        <p className="main-txt">
                            <RenderTextWithBreaks text={error_message} />
                        </p>
                        <div className="btn-container">
                            <div
                                className="btn close-btn"
                                onClick={onClose}
                            >
                                닫기
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ErrorModal;
